var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Xmark } from 'iconoir-react';
import { classNames } from '../utils';
import Badge from './Badge';
function Chip(_a) {
    var { className, variant, size, rounded, label, onDelete, disabled, icon } = _a, props = __rest(_a, ["className", "variant", "size", "rounded", "label", "onDelete", "disabled", "icon"]);
    return (_jsxs(Badge, Object.assign({ variant: variant, size: size, rounded: rounded, className: classNames(onDelete && 'pr-1', disabled && 'opacity-50', className) }, props, { children: [icon, _jsx("span", { className: "truncate", children: label }), onDelete && (_jsx("button", { type: "button", disabled: disabled, className: classNames('ml-0.5 inline-flex items-center justify-center rounded-full p-0.5', 'hover:bg-black/10 focus:outline-none focus-visible:ring-1 focus-visible:ring-gray-500 focus-visible:ring-inset', disabled && 'cursor-not-allowed'), onClick: (e) => {
                    e.stopPropagation();
                    onDelete();
                }, "aria-label": "Remove", children: _jsx(Xmark, { className: "h-3 w-3", "aria-hidden": "true" }) }))] })));
}
export default Chip;
